export const section3 = [
  {
    id: 0,
    path: "/images/sequence/section-3/1.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 1,
    path: "/images/sequence/section-3/2.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 2,
    path: "/images/sequence/section-3/3.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 3,
    path: "/images/sequence/section-3/4.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 4,
    path: "/images/sequence/section-3/5.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 5,
    path: "/images/sequence/section-3/6.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 6,
    path: "/images/sequence/section-3/7.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 7,
    path: "/images/sequence/section-3/8.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 8,
    path: "/images/sequence/section-3/9.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 9,
    path: "/images/sequence/section-3/10.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 10,
    path: "/images/sequence/section-3/11.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 11,
    path: "/images/sequence/section-3/12.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 12,
    path: "/images/sequence/section-3/13.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 13,
    path: "/images/sequence/section-3/14.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 14,
    path: "/images/sequence/section-3/15.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 15,
    path: "/images/sequence/section-3/16.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 16,
    path: "/images/sequence/section-3/17.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 17,
    path: "/images/sequence/section-3/18.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 18,
    path: "/images/sequence/section-3/19.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 19,
    path: "/images/sequence/section-3/20.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 20,
    path: "/images/sequence/section-3/21.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 21,
    path: "/images/sequence/section-3/22.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 22,
    path: "/images/sequence/section-3/23.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 23,
    path: "/images/sequence/section-3/24.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 24,
    path: "/images/sequence/section-3/25.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 25,
    path: "/images/sequence/section-3/26.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 26,
    path: "/images/sequence/section-3/27.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 27,
    path: "/images/sequence/section-3/28.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 28,
    path: "/images/sequence/section-3/29.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 29,
    path: "/images/sequence/section-3/30.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 30,
    path: "/images/sequence/section-3/31.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 31,
    path: "/images/sequence/section-3/32.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 32,
    path: "/images/sequence/section-3/33.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 33,
    path: "/images/sequence/section-3/34.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 34,
    path: "/images/sequence/section-3/35.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 35,
    path: "/images/sequence/section-3/36.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 36,
    path: "/images/sequence/section-3/37.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 37,
    path: "/images/sequence/section-3/38.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 38,
    path: "/images/sequence/section-3/39.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 39,
    path: "/images/sequence/section-3/40.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 40,
    path: "/images/sequence/section-3/41.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 41,
    path: "/images/sequence/section-3/42.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 42,
    path: "/images/sequence/section-3/43.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 43,
    path: "/images/sequence/section-3/44.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 44,
    path: "/images/sequence/section-3/45.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 45,
    path: "/images/sequence/section-3/46.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 46,
    path: "/images/sequence/section-3/47.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 47,
    path: "/images/sequence/section-3/48.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 48,
    path: "/images/sequence/section-3/49.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 49,
    path: "/images/sequence/section-3/50.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 50,
    path: "/images/sequence/section-3/51.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 51,
    path: "/images/sequence/section-3/52.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 52,
    path: "/images/sequence/section-3/53.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 53,
    path: "/images/sequence/section-3/54.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 54,
    path: "/images/sequence/section-3/55.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 55,
    path: "/images/sequence/section-3/56.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 56,
    path: "/images/sequence/section-3/57.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 57,
    path: "/images/sequence/section-3/58.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 58,
    path: "/images/sequence/section-3/59.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 59,
    path: "/images/sequence/section-3/60.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 60,
    path: "/images/sequence/section-3/61.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 61,
    path: "/images/sequence/section-3/62.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 62,
    path: "/images/sequence/section-3/63.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 63,
    path: "/images/sequence/section-3/64.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 64,
    path: "/images/sequence/section-3/65.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 65,
    path: "/images/sequence/section-3/66.jpg",
    loaded: false,
    asset: null
  },
  {
    id: 66,
    path: "/images/sequence/section-3/67.jpg",
    loaded: false,
    asset: null
  }
]
